import {
  Box,
  Grid,
  makeStyles,
  Paper,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow
} from "@material-ui/core";
import VisibilityIcon from "@material-ui/icons/Visibility";
import React, { useCallback, useEffect, useRef, useState } from "react";

import { CircularProgress } from "@material-ui/core";
import DeleteIcon from "@material-ui/icons/Delete";
import moment from "moment";
import { LuArrowDown, LuArrowDownUp, LuArrowUp } from "react-icons/lu";
import { UploadCSVModal } from "../../../components/Common/CsvUploader";
import CustomAddModal from "../../../components/Common/CustomAddModal";
import CustomConfirmModal from "../../../components/Common/CustomConfirmModal";
import CustomPagination from "../../../components/Common/CustomPagination";
import { getCurrentUserId, getCurrentUserOrganizationId, toastError, toastSuccess } from "../../../utils";
import * as actions from "./actions";

import _ from "lodash";
import SearchBar from "../../../common/Search";
import CustomTabs from "../../../common/Tabs";
import CustomShowModal from "../../../components/Common/CustomShowModal";
import AddUpdateDetails from "./AddUpdateDetails";

const useStyles = makeStyles({
  root: {
    width: "fit-content",
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
  },
});

const initialSearchType = {
  type: "",
  saveLabel: "",
  name: "",
  firstLoadPort: "",
  lastDischargePort: "",
  loadQuantity: "",
  createdDate: "",
};

function AddressBook(props) {
  const { loader = false, setLoader = () => { } } = props;
  const classes = useStyles();
  const currentUserOrganizationId = getCurrentUserOrganizationId();
  const currentUser = getCurrentUserId();
  const [value, setValue] = useState(1);
  const [open, setOpen] = useState({
    add: false,
    edit: false,
  });
  const [isEdit, setIsEdit] = useState(false);

  const [savedResults, setSavedResults] = useState([]);
  const [searchType, setSearchType] = useState({ ...initialSearchType });
  const [validDocuments, setValidDocuments] = useState([])
  const [singleResults, setSingleResults] = useState({});
  const [warningModal, setWarningModal] = useState(false);
  const [myFilters, setMyFilters] = useState({
    limit: 50,
    offset: 1,
    sortBy: "createdAt",
    sortDirection: "desc",
  });


  const [deleteModal, setDeleteModal] = useState(false);
  const [deleteId, setDeleteId] = useState({});


  // const organizationId = getCurrentUserOrganizationId();
  const addDetailsModalRef = useRef();

  const [searchValue, setSearchValue] = useState("");
  const onSearchVessel = (search) => {
    getAllSavedResults(search);
  };
  const delaySearch = useCallback(
    _.debounce((data) => onSearchVessel(data), 500),
    []
  );
  const onSearchChange = (e) => {
    setSearchValue(e.target.value)
    delaySearch(e.target.value);
  }
  const [hasFetched, setHasFetched] = useState(false);
  const [isInitialLoading, setIsInitialLoading] = useState(true);

  useEffect(() => {
    getAllSavedResults();
  }, [value, myFilters.offset, myFilters.sortBy, myFilters.sortDirection]);
  const onCloseModal = () => {
    setOpen({
      add: false,
      edit: false,
    });
    setIsEdit(false);
  };
  const getAllSavedResults = async (search) => {
    if (!hasFetched && (!savedResults || savedResults.length === 0)) {
      setIsInitialLoading(true);
      setLoader(true);
    }
    const type = value === 1 ? "user" : "organization";
    await actions
      .getAddressDetails({
        userId: getCurrentUserId(),
        search: search,
        addressBookType: type,
        offset: myFilters.offset,
        perPage: myFilters.limit,
        sortBy: myFilters.sortBy,
        sortDirection: myFilters.sortDirection
      })
      .then((res) => {
        setHasFetched(true);
        setIsInitialLoading(false);
        setLoader(false);
        setSavedResults(res?.data?.list || []);
        setMyFilters(prev => ({
          ...prev,
          totalPages: res?.data?.totalItems,
          offset: res?.data?.currentPage,
          pageCount: res?.data?.totalPages,
          limit: res?.data?.perPage
        }))
      })
      .catch((err) => {
        setHasFetched(true);
        setIsInitialLoading(false);
        setLoader(false);
        toastError(err?.data?.message);
      });
  };


  const handleChange = (event, newValue) => {
    setValue(newValue);
    setSearchType({ ...initialSearchType });
  };

  const onClickDeletAddress = (id) => {
    setDeleteId(id);
    setDeleteModal(true);
  };

  const handleSortClick = (sortKey) => {
    let newSortDirection = "asc";
    if (myFilters.sortBy === sortKey) {
      if (myFilters.sortDirection === "asc") newSortDirection = "desc";
      else if (myFilters.sortDirection === "desc") {
        newSortDirection = sortKey === "createdAt" ? "asc" : "";
      }
    } else {
      newSortDirection = sortKey === "createdAt" ? "desc" : "asc";
    }

    let nextSortBy = sortKey;
    if (!newSortDirection) {
      nextSortBy = "createdAt";
      newSortDirection = "desc";
    }

    setMyFilters((prev) => ({
      ...prev,
      offset: 1,
      sortBy: nextSortBy,
      sortDirection: newSortDirection,
    }));
  };

  const onChangeMyPagination = (type = "") => {
    let newMyFilters = {};
    if (type === "inc") {
      newMyFilters = { ...myFilters, offset: myFilters.offset + 1 };
    } else if (type === "first") {
      newMyFilters = { ...myFilters, offset: 1 };
    } else {
      if (myFilters.offset === 1) return;
      newMyFilters = { ...myFilters, offset: myFilters.offset - 1 };
    }
    setMyFilters(newMyFilters);
  };

  const onDeleteAddress = () => {
    actions
      .deleteAddressDetails(deleteId)
      .then((res) => {
        toastSuccess("Result deleted successfully");
        setDeleteModal(false);
        setDeleteId("");
        getAllSavedResults();
      })
      .catch((err) => {
        toastError(err?.data?.message);
      });
  };
  const onSubmitConfirm = () => {
    if (isEdit) {
      setWarningModal(true);
    } else {
      if (addDetailsModalRef.current && addDetailsModalRef.current.onSubmitQuery) {
        addDetailsModalRef.current.onSubmitQuery();
      }
    }
  };

  const onClickEditAddress = async (item) => {
    await actions
      .getSingleAddressDetails({ userId: getCurrentUserId(), addressid: item?._id, addressBookType: value === 1 ? "user" : "organization" })
      .then((res) => {
        setSingleResults(res?.data?.[0] || {});
        setIsEdit(true)
        setOpen({
          add: false,
          edit: true,
        })
      })
      .catch((err) => {
        toastError(err?.data?.message);
      });
  }

  const handleUploadSuccess = async () => {
    try {
      const finalData = validDocuments.map((item) => {
        return {
          ...item,
          addressBookType: value === 1 ? "user" : "organization",
          organizationId: value === 2 ? getCurrentUserOrganizationId() : undefined,
        }
      })
      const { data, message } = await actions.addManyAddressDetails(finalData);
      if (data.length) {
        toastSuccess(message)
        getAllSavedResults();
        setValidDocuments([])
      }
    } catch (error) {
      toastError("Error while processing uploaded CSV file.");
      console.error(error);
    }
  };
  const handleDataProcessed = (processedData) => {
    if (processedData?.validData) {
      setValidDocuments(processedData?.validData)
    }
  };
  const handleCancel = () => {
    setValidDocuments([]);
  };
  const handleDateRangeChange = async (newDateRange) => {
    const { startDate, endDate } = newDateRange;

    // Ensure dates are in ISO string format
    const formattedStartDate = startDate?.toISOString() || '';
    const formattedEndDate = endDate?.toISOString() || '';

    const { data } = await actions.getAddressDetails({
      userId: getCurrentUserId(),
      offset: myFilters.offset,
      perPage: myFilters.limit,
      addressBookType: value === 1 ? "user" : "organization",
      sortBy: myFilters.sortBy,
      sortDirection: myFilters.sortDirection,
      startDate: formattedStartDate,
      endDate: formattedEndDate,
    });
    setSavedResults(data.list);
  };

  const commonProps = {
    maxWidth: "md",
    onCloseModal,
    children: (
      <AddUpdateDetails
        type={value === 1 ? "user" : "organization"}
        ref={addDetailsModalRef}
        setLoader={setLoader}
        onCloseModal={onCloseModal}
        getAllSavedResults={getAllSavedResults}
        singleResults={singleResults}
        isEdit={isEdit}
        isReadOnly={value === 2 && currentUser !== singleResults.userId}
      />
    )
  };

  const tabs = [
    { label: "My Address Book", key: 1, tooltip: "Displays all addresses book records created by you." },
    { label: "Organization Address Book", key: 2, tooltip: "Displays all shared or created addresses book records for your organization." },
  ];

  return (
    <Grid container alignContent="flex-start" className="min-h-[calc(100vh-106px)]">
      <Grid item xs={12}>
        <div className="flex flex-col gap-1.5 w-full mb-1.5">
          {/* Top Control Bar */}
          <div className="flex items-center justify-between w-full gap-2">
            <div className="w-fit flex gap-2 items-center">
              <CustomTabs tabs={tabs} active={value} onChange={handleChange} />
            </div>

            <div className="flex items-center gap-2">
              <div className="desktop-searchbar">
                <SearchBar
                  placeholder="Search with Name, type, email, mobile or location..."
                  setSearchValue={onSearchChange}
                  searchValue={searchValue}
                  onDateRangeChange={handleDateRangeChange}
                  isMobile={false}
                />
              </div>
              <button
                onClick={() => setOpen({ add: true, edit: false })}
                className="h-7 px-3 bg-[#313C4C] hover:bg-[#1e2632] text-white text-[11px] font-medium rounded-none flex items-center justify-center gap-1.5 shadow-sm transition-colors cursor-pointer whitespace-nowrap"
              >
                Add Details
              </button>
            </div>
          </div>

          {/* Second Control Row: CSV buttons */}
          <div className="flex items-center justify-between w-full">
            <div className="mobile-searchbar">
              <SearchBar
                isMobile
                placeholder="Search with Name, type, email, mobile or location..."
                setSearchValue={onSearchChange}
                onDateRangeChange={handleDateRangeChange}
                searchValue={searchValue}
              />
            </div>
            <div className="flex justify-end w-full">
              <UploadCSVModal
                onUploadSuccess={handleUploadSuccess}
                onDataProcessed={handleDataProcessed}
                onCancel={handleCancel}
              />
            </div>
          </div>
        </div>
      </Grid>

      <Grid item xs={12}></Grid>

      <Grid item xs={12}>
        <Box pt={0.5}>
          <TableContainer component={Paper} className="!rounded-none !shadow-sm">
            {myFilters?.totalPages > myFilters?.limit && (
              <CustomPagination
                onChangePagination={onChangeMyPagination}
                filters={myFilters}
                totalPage={myFilters?.totalItems}
              />
            )}
            <style>{`
              .address-book-table thead tr th,
              .address-book-table thead tr .MuiTableCell-head {
                padding: 8px 6px !important;
              }
            `}</style>
            <Table className="universal-table w-full address-book-table">
              <TableHead className="bg-[#313C4C]">
                <TableRow>
                  {[
                    { label: "No.", sortKey: null },
                    { label: "Customer id", sortKey: null },
                    { label: "Type", sortKey: "type" },
                    { label: "Name/Full Style", sortKey: "name" },
                    { label: "Title", sortKey: "title" },
                    { label: "Location", sortKey: null },
                    { label: "Email", sortKey: "email" },
                    { label: "Mobile no", sortKey: "mobile" },
                    { label: "Created on", sortKey: "createdAt" },
                    { label: "Action", sortKey: null },
                  ].map((header, index, array) => (
                    <TableCell
                      key={header.label}
                      className={`text-white !py-2.5 !px-1.5 text-[11px] font-medium border-r border-gray-400 leading-tight ${index === array.length - 1 ? "border-r-0" : ""
                        } ${header.sortKey ? "cursor-pointer" : ""}`}
                      onClick={() => header.sortKey ? handleSortClick(header.sortKey) : undefined}
                    >
                      <div style={{ display: "flex", alignItems: "center", gap: 4 }}>
                        {header.label}
                        {header.sortKey && (
                          <div
                            style={{
                              color: myFilters.sortBy === header.sortKey ? "#fff" : "rgba(255,255,255,0.4)",
                              display: "flex",
                              alignItems: "center",
                            }}
                          >
                            {myFilters.sortBy === header.sortKey && myFilters.sortDirection === "desc" ? (
                              <LuArrowDown size={13} />
                            ) : myFilters.sortBy === header.sortKey && myFilters.sortDirection === "asc" ? (
                              <LuArrowUp size={13} />
                            ) : (
                              <LuArrowDownUp size={13} />
                            )}
                          </div>
                        )}
                      </div>
                    </TableCell>
                  ))}
                </TableRow>
              </TableHead>
              <TableBody>
                {isInitialLoading && (!Array.isArray(savedResults) || !savedResults.length) ? (
                  <TableRow>
                    <TableCell colSpan={10} align="center" className="!bg-white">
                      <Box display="flex" justifyContent="center" alignItems="center" height="440px">
                        {savedResults?.length > 0 && <CircularProgress />}
                      </Box>
                    </TableCell>
                  </TableRow>
                ) : Array.isArray(savedResults) && savedResults.length ? (
                  savedResults.map((item, index) => {
                    return (
                      <React.Fragment key={index}>
                        {item?.type === "Individual" ? (
                          <TableRow
                            onDoubleClick={() => {
                              onClickEditAddress(item);
                            }}
                            key={index}
                            className="h-7 cursor-pointer hover:bg-gray-50"
                          >
                            <TableCell className="!py-1 !px-2 text-[11px] font-medium border-gray-300">{(myFilters.offset - 1) * myFilters.limit + index + 1}</TableCell>
                            <TableCell className="!py-1 !px-2 text-[11px] font-medium border-gray-300">{item?.customerId || "-"}</TableCell>
                            <TableCell className="!py-1 !px-2 text-[11px] font-medium border-gray-300">{item?.type}</TableCell>
                            <TableCell className="!py-1 !px-2 text-[11px] font-medium border-gray-300">
                              {item?.individual_firstName}
                            </TableCell>
                            <TableCell className="!py-1 !px-2 text-[11px] font-medium border-gray-300">{item?.individual_title}</TableCell>
                            <TableCell className="!py-1 !px-2 text-[11px] font-medium border-gray-300">
                              {item?.individual_location || ""}
                            </TableCell>
                            <TableCell className="!py-1 !px-2 text-[11px] font-medium border-gray-300">
                              {item?.individual_emailPersonal || ""}
                            </TableCell>
                            <TableCell className="!py-1 !px-2 text-[11px] font-medium border-gray-300">
                              {item?.individual_mobilePersonal || ""}
                            </TableCell>
                            <TableCell className="!py-1 !px-2 text-[11px] font-medium border-gray-300">
                              {moment(item.createdAt).format("DD/MMM/yyyy")}
                            </TableCell>
                            <TableCell className="!py-1 !px-2 border-gray-300">
                              <div className="flex items-center justify-center gap-1">
                                <button
                                  onClick={() => onClickEditAddress(item)}
                                  className="p-1 text-[#313C4C] hover:text-[#1e2632] cursor-pointer"
                                  title="View"
                                >
                                  <VisibilityIcon style={{ fontSize: 14 }} />
                                </button>
                                {(value === 1 || (currentUser === item?.userId && currentUserOrganizationId === item?.organizationId)) && (
                                  <button
                                    onClick={() => onClickDeletAddress(item?._id)}
                                    className="p-1 text-rose-600 hover:text-rose-800 cursor-pointer"
                                    title="Delete"
                                  >
                                    <DeleteIcon style={{ fontSize: 14 }} />
                                  </button>
                                )}
                              </div>
                            </TableCell>
                          </TableRow>
                        ) : (
                          <TableRow
                            key={index}
                            onDoubleClick={() => {
                              onClickEditAddress(item);
                            }}
                            className="h-7 cursor-pointer hover:bg-gray-50"
                          >
                            <TableCell className="!py-1 !px-2 text-[11px] font-medium border-gray-300">{index + 1}</TableCell>
                            <TableCell className="!py-1 !px-2 text-[11px] font-medium border-gray-300">{item?.customerId || "-"}</TableCell>
                            <TableCell className="!py-1 !px-2 text-[11px] font-medium border-gray-300">{item?.type}</TableCell>
                            <TableCell className="!py-1 !px-2 text-[11px] font-medium border-gray-300">
                              {item?.organisation_fullName}
                            </TableCell>
                            <TableCell className="!py-1 !px-2 text-[11px] font-medium border-gray-300">
                              {item?.organisation_fullStyle}
                            </TableCell>
                            <TableCell className="!py-1 !px-2 text-[11px] font-medium border-gray-300">
                              {item?.organisation_officeLocation || ""}
                            </TableCell>
                            <TableCell className="!py-1 !px-2 text-[11px] font-medium border-gray-300">
                              {item?.organisation_emailOfficial || ""}
                            </TableCell>
                            <TableCell className="!py-1 !px-2 text-[11px] font-medium border-gray-300">
                              {item?.organisation_mobileOfficial || ""}
                            </TableCell>
                            <TableCell className="!py-1 !px-2 text-[11px] font-medium border-gray-300">
                              {moment(item?.createdAt).format("DD/MMM/yyyy")}
                            </TableCell>
                            <TableCell className="!py-1 !px-2 border-gray-300">
                              <div className="flex items-center justify-center gap-1">
                                <button
                                  onClick={() => onClickEditAddress(item)}
                                  className="p-1 text-[#313C4C] hover:text-[#1e2632] cursor-pointer"
                                  title="View"
                                >
                                  <VisibilityIcon style={{ fontSize: 14 }} />
                                </button>
                                {(value === 1 || (currentUser === item?.userId && currentUserOrganizationId === item?.organizationId)) && (
                                  <button
                                    onClick={() => onClickDeletAddress(item?._id)}
                                    className="p-1 text-rose-600 hover:text-rose-800 cursor-pointer"
                                    title="Delete"
                                  >
                                    <DeleteIcon style={{ fontSize: 14 }} />
                                  </button>
                                )}
                              </div>
                            </TableCell>
                          </TableRow>
                        )}
                      </React.Fragment>
                    );
                  })
                ) : (
                  <TableRow>
                    <TableCell
                      colSpan="8"
                      align="center"
                      className="!bg-white"
                    >
                      No Address Details Found.
                    </TableCell>
                  </TableRow>
                )}
              </TableBody>
            </Table>

            {myFilters?.totalPage > myFilters?.limit && (
              <CustomPagination
                onChangePagination={onChangeMyPagination}
                filters={myFilters}
                totalPage={myFilters?.totalPages}
              />
            )}
          </TableContainer>
        </Box>
      </Grid>

      <CustomConfirmModal
        open={deleteModal}
        handleClose={() => setDeleteModal(false)}
        message="Are you sure you want to delete this Address Details?"
        onSubmitConfirm={onDeleteAddress}
        type="warning"
        confirmText="DELETE"
        cancelText="Cancel"
        note="This action cannot be undone."
      />
      {open.add ? (
        <CustomAddModal
          {...commonProps}
          open={open.add}
          title={isEdit ? "Update details" : "Add details"}
          saveLabel={isEdit ? "Update" : "Create"}
          onSubmitConfirm={onSubmitConfirm}
          handleClose={onCloseModal}
        />
      ) : value === 1 ||
        (value === 2 && currentUser === singleResults.userId) ? (
        <CustomAddModal
          {...commonProps}
          open={open.add || open.edit}
          title={isEdit ? "Update details" : "Add details"}
          saveLabel={isEdit ? "Update" : "Create"}
          onSubmitConfirm={onSubmitConfirm}
          handleClose={onCloseModal}
        />
      ) : value === 2 ? (
        <CustomShowModal
          {...commonProps}
          open={open.edit}
          handleClose={onCloseModal}
          title="View details"
        />
      ) : null}

      {/* <CustomAddModal
                open={isCopyConfirm}
                handleClose={onCopyClick}
                onSubmitConfirm={onCopySaveClick}
                maxWidth="xs"
                saveLabel="Create"
                title="Copy to Org"
            >
                <ShareWithOrg
                    value={shareLabel}
                    onChange={(e) => setShareLabel(e.target.value)}
                    placeholder="Enter Voyages name*"
                />
            </CustomAddModal> */}
      <CustomConfirmModal
        open={warningModal}
        handleClose={() => setWarningModal(false)}
        message="Are you sure you want to update this Address Details?"
        onSubmitConfirm={() => {
          if (addDetailsModalRef.current.onSubmitQuery) {
            addDetailsModalRef.current.onSubmitQuery();
          }
          setWarningModal(false);
        }}
        type="warning"
        confirmText="UPDATE"
        cancelText="Cancel"
        note="This action cannot be undone."
      />
    </Grid>
  );
}

export default AddressBook;
